import React, { Component } from "react";

import CuentaSocio from "../../generico/CuentaSocio";
import PrestamoCuota from './CuotasPendientes'
import PrestamoService from "../../../services/pagos/PrestamoService"
import { trackPromise } from 'react-promise-tracker';
import { formatoSeparadorMilesValue } from '../../generico/utils/FormatoInput'
import Popup from "react-popup";
import $ from "jquery";
import authService from "../../../services/login/auth.service";
import MensajeUsuario from "../../generico/MensajeUsuario";
import {FontAwesomeIcon}  from "@fortawesome/react-fontawesome";
import {faArrowRight, faArrowLeft, faPlus} from "@fortawesome/free-solid-svg-icons";


export default class PrestamoPaso2 extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();

  }

  getInitialState = () => ({
    cuentasOrigen: [],
    detalleCuotas: [],
    cuentaSeleccionada: undefined,
    cantCuotas: undefined,
    nroCuotas: undefined,
    disabledNext: true,
  })


  componentDidMount() {
  }
  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });
  selectorValue = (ctaFullData, item) => {

    if (item.length === 0) {

      this.setState({ cuentaSeleccionada: item, disabledNext: true });
      return;
    }
    if (this.state.cantCuotas !== undefined)
      this.setState({ cuentaSeleccionada: item, disabledNext: false });
    else
      this.setState({ cuentaSeleccionada: item, disabledNext: true });
    this.props.rptPaso2Cuenta(item)
  };



  searchNumber = (value) => {


    if (value.target.value === "") {


      $(".form-validate").html("La cantidad de cuotas no puede quedar vacio");
      this.setState({ cantCuotas: undefined, disabledNext: true });
      this.props.rptPaso2Cuotas(value.target.value)
      return
    }
    if ( value.target.value === "0") {

      $(".form-validate").html("La cantidad de cuotas no puede ser 0");
      this.setState({ cantCuotas: undefined, disabledNext: true });
      return;
    }

    if (value.target.value > this.state.nroCuotas) {

      $(".form-validate").html("La cantidad de cuotas no es válida");
      this.setState({ cantCuotas: undefined, disabledNext: true });
      return;
    }
    if (this.state.cuentaSeleccionada !== undefined) {
      $(".form-validate").html("");
      this.setState({ cantCuotas: value.target.value, disabledNext: false });
      this.props.rptPaso2Cuotas(value.target.value)
    } else {

      $(".form-validate").html("");
      this.setState({ cantCuotas: value.target.value, disabledNext: true });
      this.props.rptPaso2Cuotas(value.target.value)
    }
  };

  getDetalles = (idPrestamo) => {
    var cuenta = [];
    var cuotas = [];
    trackPromise(
      PrestamoService.cuotasPendientes(idPrestamo, "S")
        .then((response) => {
          var data = JSON.stringify(response.data);
          var jsonData = JSON.parse(data);
          //console.log("json: ", jsonData);
          if (jsonData.codRespuesta === "0") {

            if(jsonData.detalleAhorro !== null){
              for (var i = 0; i < jsonData.detalleAhorro.length; i++) {

                cuenta.push({
  
                  cuenta: jsonData.detalleAhorro[i].idAhorro,
                  tipoDeCuenta: jsonData.detalleAhorro[i].descripcion,
                  saldoActual: jsonData.detalleAhorro[i].saldoTotal,
                  moneda: jsonData.detalleAhorro[i].idMoneda
  
                });
              }
            } else {
              Popup.queue(this.notifiPopup("Info", "No posee saldo suficiente en la(s) cuenta(s) de débito para continuar"));
            }
            
            for (var j = 0; j < jsonData.detalleCuotas.length; j++) {
              cuotas.push({
                id: jsonData.detalleCuotas[j].numeroCuota,
                cuota: jsonData.detalleCuotas[j].numeroCuota,
                vencimiento: jsonData.detalleCuotas[j].vencimiento,
                capital: formatoSeparadorMilesValue(jsonData.detalleCuotas[j].saldoCapital),
                interes: formatoSeparadorMilesValue(jsonData.detalleCuotas[j].interesApagar),
                ivaSinInteres: formatoSeparadorMilesValue(jsonData.detalleCuotas[j].iva),
                seguro: formatoSeparadorMilesValue(jsonData.detalleCuotas[j].seguro),
                ivaSinSeguro: formatoSeparadorMilesValue(jsonData.detalleCuotas[j].vIvaSeguro),
                total: formatoSeparadorMilesValue(jsonData.detalleCuotas[j].montoTotal),
                estado: jsonData.detalleCuotas[j].estadoCuota,

              })

            }

            this.setState({ cuentasOrigen: cuenta, detalleCuotas: cuotas, nroCuotas: cuotas.length });
          }
          else {
            Popup.queue(this.notifiPopup("Info", jsonData.codDescripcion));
            return;
          }
        }
        ).catch(function (error) {
          //authService.logout()
          console.log("Error: ", error);
        }));

  }

  render() {
    window.scrollTo(0, 0);
    return (
      <div>
        <div className="row">
          <div className="steps clearfix">
            <ul role="tablist">
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text current">
                      Selección de Préstamo
                          </span>
                  </div>
                </span>
              </li>
              <li role="tab" className="current">
                <span>
                  <div className="title">
                    <span className="title_text current">
                      Datos de Pago
                          </span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">
                      Datos de Verificación
                          </span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">Confirmación</span>
                  </div>
                </span>
              </li>
            </ul>
          </div>
        </div>
        <div className="container">
          <div className="col-md-12 tarjeta-detalle" style={{padding:15}}>
            <div className="row">
              <div className="col-md-6 col-12">
                <span> Tipo: {this.props.tipoPrestamo}</span>
                <p>Préstamo {this.props.nroPrestamo}</p>
              </div>
              <div className="col-md-6 col-12">
                <span>Monto del Préstamo:</span>
                <p>{this.props.montoPrestamo} {this.props.moneda}</p>
              </div>
            </div>  
          </div>
        </div>
       

        <form id="formulario" >
          <div className="row">
            <div className="col-md-6">
              <CuentaSocio
                operacion="DEBITO"
                tipoCuenta="AHORRO_VISTA"
                items={this.state.cuentasOrigen}
                monto={this.state.monto}
                itemSelected={this.state.itemSelected}
                selectorValue={this.selectorValue.bind(this)}
                isClearable
                noOptionsMessage={() => 'SIN DATOS'}
              />
            </div>

            <div className="col-md-6">
              <label className="input-label-bold">
                Cantidad de Cuotas a pagar *
                    </label>
              <input
                ref={this.filterInput}
                onChange={(e) => this.searchNumber(e)}
                type="number"
                min="1" max={this.state.nroCuotas}
                placeholder="Ingrese cantidad de cuotas a abonar"
                className="input-box form-control"
                name="cuota"
               
              />
              <span style={{ fontSize: "small", color: "#adadad" }}>
                Cantidad de Cuotas de 1 a {this.state.nroCuotas}
              </span>
              <div className="form-validate" style={{ paddingLeft: 0, paddingTop: 0 }}>
              </div>
            </div>
            </div>
        </form>
        <br />


        {this.props.alDia !== null && this.props.alDia !== "null" &&
          <MensajeUsuario tipo="ERROR"
          titulo="Importante."
          mensaje="El socio no se encuentra al día con las cuotas de su crédito."/>
        }
        
        {(this.props.alDia === null || this.props.alDia === "null") &&
          <MensajeUsuario tipo="INFO"
          titulo="Importante."
          mensaje2="El socio se encuentra al día con las cuotas del crédito."/>
        }
        <br />
        <div className="card collapsed-card collapsed-list-prestamo">
          <div className="card-header">
            <button className="card-tools card-tools-tab float-left btn btn-block btn-expansible-prestamo" data-card-widget="collapse">
               Cuotas Pendientes <FontAwesomeIcon icon={faPlus} className="float-right" />
                  </button>
          </div>
          <div className="card-body pad table-responsive card-body-tab">
            <PrestamoCuota cuotas={this.state.detalleCuotas} />
          </div>
        </div>
        <hr />
        <div className="row">
        <div className="col-lg-8 col-md-6">
        <label
                className="input-label-bold-obligatorio">
                (*) Campos Obligatorios
                      <br />
              </label>
        </div>
        <div className="col-lg-2 col-md-3 btn-consulta">
        <button className="btn btn-cu-quintary"
                onClick={this.props.previousStep}>
              <FontAwesomeIcon icon={faArrowLeft} />  Volver
                    </button> 
        </div>
        <div className="col-lg-2 col-md-3">
        <button
                disabled={this.state.disabledNext}
                className="btn btn-cu-primary"
                onClick={this.props.paso2Next}>
                Continuar <FontAwesomeIcon icon={faArrowRight} />
                    </button>
              <button
                hidden
                ref={(a) => (this.nextStep = a)}
                className="btn btn-cu-primary"
                onClick={this.props.nextStep}
              ></button></div>  
        </div>

      </div>
    );
  }
}